module.exports = __webpack_public_path__ + "img/P150T_weapon_18.8d3e042b.png";